const LICENSE_API =
  process.env.REACT_APP_LICENSE_API || 'https://glitchcloud.app/license-api';

/**
 * Fetch vers le serveur scanner.
 * Essaie d'abord le chemin direct (rétro-compatible avec la prod).
 * Si CORS/réseau bloque (devtunnel / Mini-App Telegram), bascule sur le proxy license-server.
 *
 * NOTE: Pour le proxy, on envoie le body sans Content-Type explicite (browser envoie
 * "text/plain;charset=UTF-8" par défaut pour une string body). Cela évite le preflight
 * OPTIONS (text/plain est une requête CORS "simple"), ce qui contourne le problème
 * de duplication de headers CORS nginx+express.
 * La license-server.js doit avoir express.text() pour parser ce body.
 */
export async function scannerFetch(
  vpsIp: string,
  vpsPort: string,
  path: string,
  options?: RequestInit,
): Promise<Response> {
  const directUrl = `https://${vpsIp}:${vpsPort}${path}`;
  const isBodyMethod = ['POST', 'PUT', 'PATCH'].includes(
    (options?.method || 'GET').toUpperCase(),
  );

  // 1. Try direct HTTPS
  try {
    const resp = await fetch(directUrl, {
      ...options,
      mode: 'cors',
      credentials: 'omit',
    });
    return resp;
  } catch {
    /* CORS/network block on direct — fall through to proxy */
  }

  // 2. Proxy via license-server — send body as plain text (no Content-Type header)
  //    so the browser does NOT send a CORS preflight OPTIONS request.
  //    text/plain is a "simple" CORS request type (RFC 7230), no preflight needed.
  //    The proxy handler on the server parses the string body as JSON before forwarding.
  const proxyUrl = `${LICENSE_API}/scanner-proxy/${vpsIp}/${vpsPort}${path}`;
  try {
    return await fetch(proxyUrl, {
      method: options?.method || 'GET',
      // No Content-Type header — browser will use text/plain for string bodies
      body: isBodyMethod ? options?.body : undefined,
      credentials: 'omit',
      mode: 'cors',
    });
  } catch (proxyErr) {
    const msg = proxyErr instanceof Error ? proxyErr.message : 'Network error';
    throw new Error(`Proxy unreachable: ${msg}`);
  }
}
